import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/Card';
import { Button } from '../components/Button';
import { KPICard } from '../components/KPICard';
import { ArrowLeft, Trophy, Activity, Target, ArrowRight, Users } from 'lucide-react';
import { getUnit, getPersonnelByUnit, scoreColor, KPI_FORMULA } from '../data/kpiIntelligence';
export default function KPIUnitDetail() {
  const {
    kode,
    unitId
  } = useParams();
  const navigate = useNavigate();
  const unit = getUnit(kode || '', unitId || '');
  if (!unit) {
    return <div className="flex flex-col items-center justify-center h-full space-y-4" data-id="element-1758">
        <h2 className="text-xl font-mono text-muted-foreground" data-id="element-1759">
          Data Unit tidak ditemukan
        </h2>
        <Button onClick={() => navigate(`/kpi/binda/${kode}`)} variant="outline" data-id="element-1760">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-1761" /> Kembali ke Dashboard BINDA
        </Button>
      </div>;
  }
  const personnel = getPersonnelByUnit(unit.bindaKode, unit.id);
  // Sort personnel by score
  const sortedPersonnel = [...personnel].sort((a, b) => b.score - a.score);
  return <div className="space-y-6 animate-in fade-in duration-500 max-w-7xl mx-auto pb-12" data-id="element-1762">
      <div className="flex items-center gap-4 border-b border-border/50 pb-4" data-id="element-1763">
        <Button variant="ghost" size="icon" onClick={() => navigate(`/kpi/binda/${kode}`)} className="hover:bg-primary/20 hover:text-primary" data-id="element-1764">
          <ArrowLeft className="w-5 h-5" data-id="element-1765" />
        </Button>
        <div data-id="element-1766">
          <h1 className="text-2xl font-heading font-bold tracking-tight text-foreground flex items-center gap-3" data-id="element-1767">
            {unit.nama.toUpperCase()}
            <span className="text-sm font-mono text-primary bg-primary/10 px-2 py-1 rounded border border-primary/30" data-id="element-1768">
              {unit.id}
            </span>
          </h1>
          <p className="text-muted-foreground font-mono text-xs mt-1 uppercase tracking-widest" data-id="element-1769">
            Level 3: Kinerja Unit // Peringkat BINDA: #{unit.rank}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1770">
        <KPICard title="Skor KPI Unit" value={unit.score} icon={Target} colorVar={scoreColor(unit.score)} trend={{
        value: `${unit.trend >= 0 ? '+' : ''}${unit.trend}%`,
        label: 'vs Bulan Lalu',
        isPositive: unit.trend >= 0
      }} data-id="element-1771" />
        <KPICard title="Grade" value={`Grade ${unit.grade}`} icon={Trophy} colorVar={scoreColor(unit.score)} progress={{
        value: unit.score,
        label: 'Pencapaian',
        target: '100'
      }} data-id="element-1772" />
        <KPICard title="Total Personel" value={unit.anggota} icon={Users} colorVar="var(--status-info)" data-id="element-1773" />
        <KPICard title="Rata-rata Produktivitas" value={unit.components.produktivitas} icon={Activity} colorVar={scoreColor(unit.components.produktivitas)} data-id="element-1774" />
      </div>

      {/* Komponen KPI */}
      <Card className="glass-panel border-border/50" data-id="element-1775">
        <CardHeader className="border-b border-border/50 bg-card/50" data-id="element-1776">
          <CardTitle className="text-sm font-mono uppercase tracking-widest" data-id="element-1777">
            Komponen Penilaian KPI
          </CardTitle>
        </CardHeader>
        <CardContent className="p-4" data-id="element-1778">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4" data-id="element-1779">
            {KPI_FORMULA.map(f => {
            const val = unit.components[f.key];
            return <div key={f.key} className="p-3 rounded border border-border/30 bg-background/30" data-id="element-1780">
                  <div className="text-[10px] font-mono text-muted-foreground uppercase mb-1" data-id="element-1781">
                    {f.label} ({f.bobot}%)
                  </div>
                  <div className="text-2xl font-bold font-mono" style={{
                color: scoreColor(val)
              }} data-id="element-1782">
                    {val}
                  </div>
                </div>;
          })}
          </div>
        </CardContent>
      </Card>

      {/* Ranking Personel */}
      <Card className="glass-panel border-border/50" data-id="element-1783">
        <CardHeader className="border-b border-border/50 bg-card/50" data-id="element-1784">
          <CardTitle className="text-sm font-mono uppercase tracking-widest" data-id="element-1785">
            Ranking Personel Unit
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0" data-id="element-1786">
          <div className="divide-y divide-border/30" data-id="element-1787">
            {sortedPersonnel.map((p, i) => <div key={p.id} className="flex items-center justify-between p-4 hover:bg-white/5 cursor-pointer transition-colors" onClick={() => navigate(`/kpi/personnel/${p.id}`)} data-id="element-1788">
                <div className="flex items-center gap-4" data-id="element-1789">
                  <span className="text-muted-foreground font-mono w-6 text-right text-lg" data-id="element-1790">
                    {i + 1}
                  </span>
                  <img src={p.foto} alt={p.nama} className="w-10 h-10 rounded-full border border-border/50" data-id="element-1791" />
                  <div data-id="element-1792">
                    <div className="font-bold" data-id="element-1793">{p.nama}</div>
                    <div className="text-xs font-mono text-muted-foreground" data-id="element-1794">
                      {p.pangkat} // {p.id}
                      // {p.id}
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-6" data-id="element-1795">
                  <div className="text-right hidden md:block" data-id="element-1796">
                    <div className="text-xs text-muted-foreground" data-id="element-1797">
                      Laporan Valid
                    </div>
                    <div className="font-mono" data-id="element-1798">{p.laporanValid}</div>
                  </div>
                  <div className="text-right hidden md:block" data-id="element-1799">
                    <div className="text-xs text-muted-foreground" data-id="element-1800">Respons</div>
                    <div className="font-mono" data-id="element-1801">{p.responsTugas}</div>
                  </div>
                  <div className="text-right" data-id="element-1802">
                    <div className="font-mono font-bold text-xl" style={{
                  color: scoreColor(p.score)
                }} data-id="element-1803">
                      {p.score}
                    </div>
                    <div className={`text-[10px] font-mono ${p.trend >= 0 ? 'text-green-400' : 'text-red-400'}`} data-id="element-1804">
                      {p.trend >= 0 ? '+' : ''}
                      {p.trend}%
                    </div>
                  </div>
                  <ArrowRight className="w-5 h-5 text-muted-foreground" data-id="element-1805" />
                </div>
              </div>)}
          </div>
        </CardContent>
      </Card>
    </div>;
}